import { UpdateValueCombinedProps } from './types';

const usePresenter = (props: UpdateValueCombinedProps): UpdateValueCombinedProps => {
  return props;
};

export default usePresenter;
